import request from "@/utils/request";
import { getLocalStorage } from "@/utils/local-storage";
import { data } from "jquery";
import { stringify } from "qs";
import Vue from 'vue';

function imAPI() {
  this.baseUrl = Vue.prototype.$baseURL;
  this.allocationApi = `${Vue.prototype.$baseURL}allocationRule/`;
  this.imBaseURL = `${Vue.prototype.$baseURL}api/IMAPI/`;
  this.resUrl = Vue.prototype.$resUrl
}

imAPI.prototype.Login = function (pInfo) {
  return request({
    url: this.imBaseURL + "Login",
    method: "get",
    params: {
      username: pInfo.userName,
      password: pInfo.pwd
    }
  });
};

imAPI.prototype.GetUserInfo = function (uid) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.imBaseURL + "GetUserInfo",
    method: "get",
    params: {
      userid: uid
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

imAPI.prototype.ThirdPartAuth = function (url, token) {
  return request({
    url: Vue.prototype.$authUrl + "ThirdPartAuth",
    method: "get",
    params: {
      authUrl: url,
      authToken: token
    }
  });
};

imAPI.prototype.ConfigRule = function (pInfo) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.imBaseURL + "config_rule",
    method: "get",
    params: pInfo,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//分配规则列表
imAPI.prototype.Allocation = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "allocation_rule",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//删除规则
imAPI.prototype.DeleteConfigRule = function (id) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "delete_config_rule",
    method: "get",
    params: {
      id: id
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//国家列表
imAPI.prototype.MapList = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "map_list",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//客服列表
imAPI.prototype.CSList = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "customer_service_list",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};
//语言列表
imAPI.prototype.langList = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "languageDic",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};
import axios from 'axios';
//新增分配规则
imAPI.prototype.AddConfigRule = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  console.log(JSON.stringify(data));

  return axios.post(this.allocationApi + "add_config_rule", {
    allocation_name: data.allocation_name,
    rule_value: data.rule_value,
    rule_type: data.rule_type,
    allocation_cs_id: data.allocation_cs_id,
    state: data.state,
    priority: data.priority,
    id: null
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: "Bearer " + Authorization
    }
  });
};

//修改分配规则
imAPI.prototype.updateConfigRule = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  console.log(data);

  return axios.post(this.allocationApi + "update_config_rule", {
    allocation_name: data.allocation_name,
    rule_value: data.rule_value,
    rule_type: data.rule_type,
    allocation_cs_id: data.allocation_cs_id,
    state: data.state,
    priority: data.priority,
    id: data.id
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: "Bearer " + Authorization
    }
  });
};

//获取ai默认回复
imAPI.prototype.getAIReply = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.imBaseURL + "ai_default_reply",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};
//设置ai默认回复
imAPI.prototype.setAIReply = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.imBaseURL + "ai_default_reply",
    method: "post",
    data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};
/**
 * 设置配置规则
 * @param {string} pName - 配置名称 (auto_allot/old_visitor/offline_allot/manual_allot/ai_assistant/ai_tuoguan/cs_tri/cs_braudio/cs_brhead/cs_timeout/fk_tipsaudio/fk_head)
 * @param {number} pVal - 开启状态(1开启,0关闭)
 */
imAPI.prototype.SetConfigRule = function (pName, pVal) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request.post(
    this.imBaseURL + "config_rule",
    {
      // auto_allot  old_visitor  offline_allot  manual_allot    ai_assistant   ai_tuoguan
      // cs_tri  cs_braudio   cs_brhead   cs_timeout   fk_tipsaudio   fk_head
      name: pName,//"auto_allot",
      open_state: pVal//1
    },
    {
      headers: {
        Authorization: "Bearer " + Authorization,
        'Content-Type': 'application/json'
      }
    }
  );
};

/**
 * 获取访问日志
 * @param {Object} pInfo - 查询参数
 */
imAPI.prototype.GetVisitLog = function (pInfo) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.imBaseURL + "GetVisitLog",
    method: "get",
    params: pInfo,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 上传文件
 * @param {Object} data - 上传的文件数据
 * @param {Function} upload - 上传进度回调函数
 */
imAPI.prototype.UploadFile = function (data, upload) {
  let headers = { "Content-Type": "multipart/form-data" };
  return request({
    url: this.resUrl + "UploadFile",
    method: "post",
    data: data,
    headers: headers,
    timeout: 60 * 1000,
    // onUploadProgress: function(e) {
    //   if (upload) upload(e);
    // }
  });
};

/**
 * 获取黑名单列表
 * @param {Object} data - 查询参数
 */
imAPI.prototype.GetBlackList = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "api/IMAPI/getBlackList",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 解封房间
 * @param {Object} data - 查询参数
 */
imAPI.prototype.unBlock = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "api/IMAPI/unBlock",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 获取客服列表
 * @param {Object} data - 查询参数 包含 site_id, name, phone, email, creater, page, size
 */
imAPI.prototype.getKeFuList = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "customerService/list",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 根据页面信息获取智能回复
 * ?title=${data.pageTitle}&lang=${data.siteLan}
 * @param {Object} data - 查询参数
 */
imAPI.prototype.getReplyByTitle = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + `customerService/getReplyByTitle`,
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 获取聊天记录列表
 * @param {Object} data - 查询参数
 */
imAPI.prototype.getChaLogList = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "chatlog/chatList",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};


/**
 * 获取房间列表
 * @param {Object} param - 查询参数对象
 * @param {string} param.username - 用户名
 * @param {string} param.country - 国家
 * @param {string} param.kefuId - 客服ID
 * @param {boolean} param.isStayInfo - 是否包含停留信息
 * @param {string} param.email - 邮箱
 * @param {string} param.date - 日期
 * @param {number} param.page - 页码
 * @param {number} param.size - 每页数量
 */
imAPI.prototype.getRoomList = function ({ username, country, kefuId, email, phone, siteId, labels, startTime, endTime, page, size, isStayInfo, IsEffective, blackType, blackTime,ip }) {
  const { Authorization } = getLocalStorage("Authorization") || "";

  return request({
    url: this.baseUrl + "chatlog/roomList",
    method: "post",
    data: {
      username, country, kefuId, email, phone, siteId, labels, startTime, endTime, page, size, isStayInfo, IsEffective, blackType, blackTime,ip
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

/**
 * 获取表单列表
 */
imAPI.prototype.getMsgFormList = function ({ username, kfId, name, email, phone, message, startTime, endTime, page, size }) {
  const { Authorization } = getLocalStorage("Authorization") || "";

  return request({
    url: this.baseUrl + "message/selectMsgForm",
    method: "get",
    params: {
      username, kfId, name, email, phone, message, startTime, endTime, page, size
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};



//开关手动分配规则
imAPI.prototype.switchingRules = function (openState) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.allocationApi + "switching_rules",
    method: "get",
    params: {
      openState
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//域名map
imAPI.prototype.domainMap = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "chatlog/domain_map",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

// 修改房间留资
imAPI.prototype.visitorLz = function (params) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "chatlog/visitor_lz",
    method: "get",
    params: {
      ...params
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

//访客列表所在地区
imAPI.prototype.getArea = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "allocationRule/map_list",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

//拉黑
imAPI.prototype.addBlock = function ({ roomId, timeSec, type }) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "chatlog/block_visitor",
    method: "get",
    headers: {
      Authorization: "Bearer " + Authorization
    },
    params: {
      roomId,
      timeSec,
      type
    }
  });
};

/*
* 语术库
*/
// 1、添加快捷回复
imAPI.prototype.QuickReplyAdd = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/add",
    method: "post",
    headers: {
      Authorization: "Bearer " + Authorization
    },
    data
  });
};

// 2、查询快捷回复
imAPI.prototype.QuickReplySelect = function (pInfo) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/select",
    method: "get",
    params: { // 没有必填的参数 不填查全部
      isPublic: pInfo.isPublic, // true公开 false私人
      name: pInfo.name, // 模糊查询问或答
      libraryId: pInfo.libraryId, // 库id
      classifyId: pInfo.classifyId, // 分类id
      page: pInfo.page,
      size: pInfo.pageSize,
    },
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

// 3、修改快捷回复
imAPI.prototype.QuickReplyUpdate = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/update",
    method: "post",
    headers: {
      Authorization: "Bearer " + Authorization
    },
    data
  });
};

// 4、删除快捷回复 id
imAPI.prototype.QuickReplyDelete = function (id) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/delete?id=" + id,
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

// 5、添加库或分类
imAPI.prototype.replyClassifyAdd = function (pInfo) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "replyClassify/add",
    method: "get",
    params: {
      name: pInfo.name,
      isPublic: pInfo.isPublic, // true公开 false私人
      type: pInfo.type, // 1库 2分类
      libraryId: pInfo.libraryId, // 创建分类时填对应库id，非必填
    },
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

// 6、查询库和分类 --  true公开 false私人，不填查所有
imAPI.prototype.replyClassifySelect = function (isPublic) {
  const { Authorization } = getLocalStorage("Authorization") || {};
  return request({
    url: this.baseUrl + "replyClassify/select",
    method: "get",
    params: {
      isPublic: isPublic // 当 isPublic=undefined 时，参数不会出现在 URL 中
    },
    headers: {
      Authorization: "Bearer " + Authorization
    }
  });
};

// 7、修改库名或分类名
imAPI.prototype.replyClassifyUpdate = function (pInfo) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "replyClassify/update",
    method: "get",
    params: {
      id: pInfo.id,
      name: pInfo.name,
    },
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

// 8、删除库或分类（对应子目录也会被删除）
imAPI.prototype.replyClassifyDelete = function (id) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "replyClassify/delete?id=" + id,
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

// 获取ai自动回复状态
imAPI.prototype.getAIAutoReply = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/open_priority",
    method: "GET",
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};
// 修改ai自动回复状态
imAPI.prototype.updateAIAutoReply = function () {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/open_priority",
    method: "POST",
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};
/******************** 导入导出话术库 ***************************/
// 导出话术库（指定库id）
imAPI.prototype.replyExcelDownload = function (id) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "replyExcel/download?libraryId=" + id,
    method: "GET",
    headers: {
      Authorization: "Bearer " + Authorization
    },
    responseType: 'blob'
  });
};

// 导入excel表
imAPI.prototype.replyExcelUpload = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "replyExcel/upload",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + Authorization
    },
  });
};

// 获取快速回复的内容接口
imAPI.prototype.quickReplyGetReply = function (data) {
  const { Authorization } = getLocalStorage("Authorization") || "";
  return request({
    url: this.baseUrl + "quickReply/get_reply",
    method: "POST",
    data,
    headers: {
      Authorization: "Bearer " + Authorization
    },
  });
};

export default imAPI;
